









































import { Component, Vue } from 'vue-property-decorator'
import { ProjectAdminService as _projectAdminService } from '@/admin/services/projectAdmin.service'
import { PaginationDto } from '@/models/dtos/paginationDto'
import router from '@/router'
import { mixins } from 'vue-class-component'
import { SimpleProjectDto } from '@/models/dtos/simpleProjectDto'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'
import moment from 'moment'
import { mixin } from 'vue/types/umd'
import { ProjectMixin } from '@/mixins/projectMixin'

@Component
export default class AdminProjectList extends mixins(ProjectMixin) {
  // Data
  private project: PagedResponseDto<SimpleProjectDto> | null = null
  private pagination: PaginationDto = { pageNumber: 1, pageSize: 15 }

  private projectItems: {
    id: string;
    name: string;
    created: string;
    status: string;
  }[] = []

  private projectFields = [
    { key: 'name', label: 'Nazwa', class: 'align-middle' },
    { key: 'created', label: 'Stworzono', class: 'align-middle' },
    { key: 'status', label: 'Status', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  // Methods
  private async initProjects() {
    this.project = await _projectAdminService.getAll(this.pagination.pageNumber, this.pagination.pageSize)

    this.projectItems = []
    for (const project of this.project.items) {
      this.projectItems.push({
        id: project.id!,
        name: project.name,
        created: moment(project.created).format('llll'),
        status: this.statusName(project.status)
      })
    }
  }

  private async removeProject(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć?', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _projectAdminService.remove(id)
      this.initProjects()
    }
  }

  private async editProject(id: string) {
    router.push({ name: 'ProjectEdit', params: { id } })
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.project
  }

  // Lifecycle
  async created() {
    this.initProjects()
  }
}
